// reports/ReportPage.tsx
import React, { useEffect, useState } from "react";
import { Alert, Box, Stack, Typography } from "@mui/material";

import { fetchCarrierOptions, fetchCustomerOptions } from "./ReportapiService";
import type { SelectOption } from "./Types";
import { useReport } from "./Usereport";
import ReportFilterBar from "./Reportfilterbar";
import ReportTable from "./Reporttable";

const ReportPage: React.FC = () => {
  const {
    mode,
    setMode,
    filters,
    setFilter,
    reset,
    generate,
    rows,
    loading,
    error,
    hasGenerated,
    canGenerate,
    dateError,
  } = useReport("air");

  const [customerOptions, setCustomerOptions] = useState<SelectOption[]>([]);
  const [carrierOptions, setCarrierOptions] = useState<SelectOption[]>([]);
 
  useEffect(() => {
    fetchCustomerOptions().then(setCustomerOptions);
  }, []);

  // Carriers differ by mode → reload whenever the mode toggle changes.
  useEffect(() => {
    fetchCarrierOptions(mode).then(setCarrierOptions);
  }, [mode]);

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
        Shipment Report
      </Typography>

      <ReportFilterBar
        mode={mode}
        onModeChange={setMode}
        filters={filters}
        setFilter={setFilter}
        onGenerate={generate}
        onReset={reset}
        canGenerate={canGenerate}
        dateError={dateError}
        loading={loading}
        customerOptions={customerOptions}
        carrierOptions={carrierOptions}
      />

      {error && (
        <Stack sx={{ mt: 2 }}>
          <Alert severity="error">{error}</Alert>
        </Stack>
      )}

      {/* Same table component; column set + fetch follow `mode` */}
      <ReportTable
        mode={mode}
        rows={rows}
        hasGenerated={hasGenerated}
        loading={loading}
        filters={filters}
      />
    </Box>
  );
};

export default ReportPage;

/* Route (single page):
 *   import ReportPage from "./features/reports/ReportPage";
 *   <Route path="/report" element={<ReportPage />} />
 */